/**
 * created by xcc on 2021/10/20
 * 新媒体管理页面
 */
import React, {Component} from 'react';
import {Button, Dropdown, Select, Tabs, Menu, Modal, Input, Empty, DatePicker, Pagination, Divider} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import {NAVIGATE_OPEN} from "../../../../constants";
import {connect} from "react-redux";
import {
    getAllNewMediaList,
    getBatchTransferNewMedias,
    getBatchAddData,
    getInitMediaPlatformData,
    getMeHandleCountData,
    getNewMediaById,
    getRecordDeptByIds,
    getTodoListList,
    exportMediaData,
    getTempBatchAddData,
    getTransferUsers,
    transferNewMedias,
    getDouYinList,
    getWechatList,
    getWeiBoList, getFlowEndData, getActHistory, getCurrentDeptByIds
} from "../../actions/newMediaManage";
import card from './images/card.png';
import otherCard from './images/otherCard.png';
import list from './images/list.png';
import otherList from './images/otherList.png';
import weChat from './images/weChat.png';
import microBlog from './images/microBlog.png';
import tiktok from './images/tiktok.png';
import noImg from './images/noImg.png';
import Scrollbars from "react-custom-scrollbars";
import NewMediaInformation from "./NewMediaInformation";
import NewAddMedia from "./NewAddMedia";
import BatchComponents from "./BatchComponents";
import NewMediaManageList from "./NewMediaManageList";
import {uuid, openNewWindow, formatDate, transferSpecialCharacter} from "../../../../utils";
import SelectTable from "../../../../components/selectTable/SelectTable";
import CustomTable from "../../../components/customTable/CustomTable";
import WeChatReview from "../../../components/weChatReview/WeChatReview";
import MicroBlogReview from "../../../components/microBlogReview/MicroBlogReview";
import TiktokReview from "../../../components/tiktokReview/TiktokReview";
import $ from "jquery";
import moment from "moment";
import eventProxy from "../../../../utils/eventProxy";
import BaseComponent from "../../../../base/BaseComponent";
import { formatCount } from '../../../../utils'

const {TabPane} = Tabs;
const {Option} = Select;
const {Search} = Input;
const {RangePicker} = DatePicker;
let height = window.innerHeight - 101;
let constantsWidth = document.body.clientWidth - NAVIGATE_OPEN;
let itemWidth = (constantsWidth - 140) / 4;

class NewMediaManagement extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            showCurrentPageType: "mainPage", //  批量/首页
            pageNum: 1,
            pageSize: 10,
            selectKey: '1',
            meHandleDataLength: 0,
            mediaPlatform: [],
            mainDutyDept: [],
            newMediaTypeId: undefined,  //设为null时placeholder不起作用
            mainDeptId: undefined,
            activeType: undefined,
            grade: undefined,
            cardChecked: true,
            listChecked: false,
            batchTitle: "",
            batchAuditValue: undefined,
            showListOrCard: "cardPage",
            currentMedia: {},  //当前媒体
            selectTypeVisible: false, //导出
            allMediaAccountChecked: false,
            isDisabled: false,
            selectType: [],
            listData: [], //列表模式
            newMediaListData: [], //卡片模式
            idArr: [], //id数组
            //历史发文
            visibleHistory: false,
            historyTitle: "",
            historyRecord: {},
            //选择媒体
            mediaRoleValue: "",
            chooseUserVisible: false,
            mtSqrInfos: [],
            page: 1,
            size: 10,
            transferTotal: 0,
            code: "",
            createBy: "",
            //批量数据
            batchData: [], //批量转交、批量审核数据
            batchAddData: [],  //批量暂存数据,
            //媒体等级
            num1: 0,
            num2: 0,
            num3: 0,
            id: "",
            statusName: "",
            uuid: "",
            processType: null,
            noPassCount: 0, //审核不通过数量
            selectSearchValue: "",
            title: "",
            loadListKey: uuid()
        }
    }

    componentWillMount() {
        if(!this.permissionCheck("pms:accountManage:all")){
            this.setState({
                mainDeptId: window.top.currentUser.defaultInfo.dept.id
            })
        }
    }

    componentDidMount() {
        //初始化媒体平台
        this.getMediaPlatInitData();
        //初始化主责单位
        this.getMainDutyDeptInitData();
        //新媒体列表数据
        this.getNeedAuditMedia();
        //媒体总览跳转
        eventProxy.on('auditing', () => {
            this.setState({
                selectKey: "3"
            })
        })
        //事件监听
        // window.addEventListener('resize', this.resize.bind(this));
    }

    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;   //防止内存泄露
        };
    }

    // resize() {
    //     window.location.reload();   //重新加载页面，类似f5刷新
    // }
    //
    // componentWillUnmount() {
    //     // 一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
    //     window.removeEventListener('resize', this.resize);
    // }

    /**
     * 初始化媒体平台
     **/
    getMediaPlatInitData() {
        let params = {
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize
        };
        getInitMediaPlatformData(params, (data) => {
            let mediaPlatform = [];
            if (data && data.length > 0) {
                mediaPlatform = data;
                mediaPlatform.forEach(item => {
                    if (!item.logoPath) {
                        switch (item.type) {
                            case 2:
                                item.logoPath = weChat;
                                break;
                            case 3:
                                item.logoPath = microBlog;
                                break;
                            case 5:
                                item.logoPath = tiktok;
                                break;
                            default :
                                item.logoPath = "";
                        }
                    }
                })
            }
            this.setState({
                mediaPlatform
            })
        })
    }

    /**
     * 初始化主责单位
     **/
    getMainDutyDeptInitData() {
        if (this.permissionCheck("pms:accountManage:all")) {
            getRecordDeptByIds(["0"], (data) => {
                let mainDutyDept = [];
                if (data && data.length > 0) {
                    mainDutyDept = data;
                }
                this.setState({
                    mainDutyDept
                });
            });
        } else {
            getCurrentDeptByIds(window.top.currentUser.deptIds, (data) => {
                let mainDutyDept = [];
                if (data && data.length > 0) {
                    mainDutyDept = data;
                }
                this.setState({
                    mainDutyDept
                });
            });
        }
    }

    /**
     * 待我处理数量
     **/
    getNeedMeHandleCount(mediaCodes) {
        let params = {
            codes: mediaCodes
        }
        getMeHandleCountData(params, (data) => {
            if (data || data === 0) {
                this.setState({
                    meHandleDataLength: data
                })
            }
        })
    }

    /**
     * 根据流程接口获取数据
     **/
    getNeedAuditMedia(callback) {
        let params = {
            operatorUser: window.top.currentUser.id,
            activitiCategoryKeys: ["mediaAudit"],
            page: {
                size: 10000,
                start: 1
            },
            showData: true
        };
        getTodoListList(params, (needTodoData, mediaCodes) => {
            //审核不通过数量
            // this.getNoPass();
            //待我处理数量
            this.getNeedMeHandleCount(mediaCodes);
            //媒体列表数据
            if (this.state.selectKey === "2") {
                this.getNewMediaList(needTodoData, mediaCodes, callback);
            } else {
                this.getNewMediaList();
            }
        });
    }

    /**
     * 获取审核不通过数量
     */
    getNoPass() {
        let params = {
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize,
            statusType: 2
        };
        if (this.permissionCheck("pms:accountManage:all")) {

        } else if (this.permissionCheck("pms:accountManage:dept")) {
            params.createUserDeptIds = [window.top.currentUser.defaultInfo.dept.id];  //部门权限
        } else {
            params.createBy = window.top.currentUser.id;  //个人权限
        }
        getAllNewMediaList(params, (data) => {
            if (data && data.length > 0) {
                this.setState({
                    noPassCount: data.length
                })
            } else {
                this.setState({
                    noPassCount: 0
                })
            }
        })
    }

    /**
     * 获取媒体列表数据
     */
    getNewMediaList(needTodoData, mediaCodes, callback) {
        let params = {
            pageNum: 1,
            pageSize: 10000,
        };

        if (this.state.selectKey !== "2") {
            if (this.permissionCheck("pms:accountManage:all")) {

            } else if (this.permissionCheck("pms:accountManage:dept")) {
                params.createUserDeptIds = [window.top.currentUser.defaultInfo.dept.id];  //部门权限
            } else {
                params.createBy = window.top.currentUser.id;  //个人权限
            }
        }

        if (this.state.mainDeptId) {
            params.mainDeptId = this.state.mainDeptId;  //主责单位
        }

        if (this.state.newMediaTypeId) {
            params.newMediaTypeId = this.state.newMediaTypeId;  //媒体平台
        }

        if (this.state.activeType || this.state.activeType === 0) {
            params.activeType = this.state.activeType;  //活跃度
        }

        if (this.state.grade) {
            params.grade = [this.state.grade];  //媒体等级
        }

        if (this.state.selectKey === "1") {
            params.statusType = 0;  //已备案
        }

        if (this.state.selectKey === '2' || this.state.batchAuditValue || this.state.batchAuditValue === 0) {
            if (mediaCodes && mediaCodes.length > 0) {
                params.codes = mediaCodes;  //待我处理
            } else {
                params.codes = ["default"];
            }
        }

        if (this.state.selectKey === "3") {
            params.statusType = 1;   //审核中
        }

        if (this.state.selectKey === "4") {
            params.statusType = 2;  //审核不通过
        }

        if (this.state.selectKey === "6") {
            params.statusType = 3;  //已注销
        }

        if (this.state.selectKey === "5") {
            params.statusType = 4;  //未备案
        }

        if (this.state.selectKey === "7") {
            params.statusType = 5;  //草稿
        }

        if (this.state.batchAuditValue || this.state.batchAuditValue === 0) {
            params.processType = this.state.batchAuditValue;
        }
        getAllNewMediaList(params, (_data) => {
            if (_data && _data.length > 0) {
                let newData = _data;
                let idArr = [];
                let gradeArr = [];
                newData.forEach((item, i) => {
                    if (item.newMediaTypeName === "微信") {
                        item.iconType = weChat;//微信
                        item.authentication = true;//微信的都是已认证
                    } else if (item.newMediaTypeName === "微博") {
                        item.iconType = microBlog;//微博
                    } else if (item.newMediaTypeName === "抖音") {
                        item.iconType = tiktok;//抖音
                    } else if (item.newMediaTypeName === "其他") {
                        item.iconType = noImg;//其他媒体
                    }
                    item.checked = false;
                    idArr.push(item.id);
                    gradeArr.push(item.grade);
                });

                //计算各筛选项媒体等级数量
                let num1 = 0;
                let num2 = 0;
                let num3 = 0;
                gradeArr.length > 0 && gradeArr.forEach(item => {
                    if (item === "first") {
                        num1++;
                    }
                    if (item === "second") {
                        num2++;
                    }
                    if (item === "third") {
                        num3++;
                    }
                })

                this.state.idArr = idArr;  //拿出筛选出的id数组供导出使用

                //组织数据
                // if (this.state.showListOrCard === "listPage") {
                //     this.newMediaListManage.state.checkedAll = true;
                //     newData.forEach(item => {
                //         item.checked = true;
                //     });
                // }

                let sortNewData;
                let finalData;
                if (needTodoData && needTodoData.length > 0) {
                    sortNewData = this.sortNeedTodoData(needTodoData, newData);

                    //如果是批量审核
                    if (this.state.batchAuditValue || this.state.batchAuditValue === 0) {
                        // sortNewData.forEach(item => {
                        //     item.checked = true;
                        // })
                        this.state.batchData = sortNewData;
                        callback(sortNewData);
                    }

                    //排序把待我处理的数据排列在数组前面，其他的放在后面
                    finalData = this.getData(sortNewData, "newMediaTypeName");
                } else {
                    finalData = this.getData(newData, "newMediaTypeName");
                }
                this.setState({
                    newMediaListData: finalData,
                    listData: newData,
                    loadListKey: uuid()
                });
                if (!this.state.grade) {
                    this.setState({
                        num1,
                        num2,
                        num3
                    });
                }
            } else {
                this.setState({
                    newMediaListData: [],
                    listData: [],
                    batchData: [],
                    idArr: [],
                });
                if (!this.state.grade) {
                    this.setState({
                        num1: 0,
                        num2: 0,
                        num3: 0
                    });
                }
            }

        });
    }

    getData(arr, param) {
        let map = {},
            dest = [];
        let otherArr = [];
        for (let i = 0; i < arr.length; i++) {
            let ai = arr[i];
            if (ai[param] && !map[ai[param]]) {
                if (ai[param] !== "公众号" && ai[param] !== "微博" && ai[param] !== "抖音") {
                    otherArr.push(ai[param])
                }
                dest.push({
                    name: ai[param],
                    logo: this.getLogo(ai),
                    isExpand: false,
                    data: [ai]
                });
                map[ai[param]] = ai;
            } else {
                for (let j = 0; j < dest.length; j++) {
                    let dj = dest[j];
                    if (dj.name === ai[param]) {
                        dj.data.push(ai);
                        break;
                    }
                }
            }
        }
        //公众号、微博、抖音的数据排在前面  dest按照mediaArr的顺序排列
        let mediaArr = ["公众号", "微博", "抖音", ...otherArr];
        dest.sort(function (a, b) {
            return mediaArr.map(item => item).indexOf(a.name) < mediaArr.map(item => item).indexOf(b.name) ? -1 : 1
        })
        return dest;
    }

    getLogo(item) {
        let logoPath;
        this.state.mediaPlatform.length > 0 && this.state.mediaPlatform.forEach(i => {
            if (item.newMediaTypeId === i.id) {
                logoPath = i.logoPath;
            }
        })
        return logoPath;
    }

    //排序需要待办的媒体数据，
    sortNeedTodoData = (needData, allData) => {
        let sortData = [];
        //待办的数据放在数组前面，
        for (let i = 0, length = allData.length; i < length; i++) {
            if (!allData[i]) {
                continue;
            }
            if (needData.indexOf(allData[i].id) >= 0) {
                allData[i].needTodo = true;
                sortData.push(allData[i]);
            }
        }

        //非待办的放在数组后面，
        for (let i = 0, length = allData.length; i < length; i++) {
            if (needData.indexOf(allData[i].id) < 0) {
                sortData.push(allData[i]);
            }
        }
        return sortData;
    }

    /**
     * tab切换
     */
    handleTextChange = activeKey => {
        window.loading.show()
        this.setState({
            selectKey: activeKey,
            newMediaTypeId: undefined,
            mainDeptId: this.permissionCheck("pms:accountManage:all") ? undefined : window.top.currentUser.defaultInfo.dept.id,
            activeType: undefined,
            grade: undefined,
        }, () => {
            setTimeout(() => {
                window.loading.hide()
                this.getNeedAuditMedia();
            }, 500)
        });
    };

    /**
     * 全选
     */
    checkedAllChange(checked) {
        this.state.batchData.forEach(item => {
            item.checked = checked;
        });
        this.setState({})
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{padding: "15px", borderRadius: "2px"}}>
                <div style={{display: this.state.showCurrentPageType === "mainPage" ? "block" : "none"}}>
                    {this.renderMainPage()}
                </div>
                <div style={{display: this.state.showCurrentPageType === "batchPage" ? "block" : "none"}}>
                    {this.renderBatchPage()}
                </div>
                {/*以下方法写会存在组件被卸载情况，导致组件不能重新渲染*/}
                {/*{this.state.showCurrentPageType === "mainPage" ? this.renderMainPage() : null}*/}
                {/*{this.state.showCurrentPageType === "batchPage" ? this.renderBatchPage() : null}*/}
            </div>
        )
    }

    renderMainPage() {
        let tabList = [{title: '已备案', key: '1'}, {title: '待我处理', key: '2'}, {title: '审核中', key: '3'},
            {title: '审核不通过', key: '4'}, {title: '未备案', key: '5'}, {title: '已注销', key: '6'}, {title: '草稿', key: '7'}];
        return (
            <div style={{
                width: "100%",
                height: height - 15,
                position: "relative"
            }}>
                <div style={{
                    backgroundColor: "red",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    position: "absolute",
                    top: 18,
                    left: 193,
                    zIndex: 200,
                    color: "#fff",
                    textAlign: "center",
                    lineHeight: "20px",
                    display: this.state.meHandleDataLength > 0 ? "block" : "none"
                }}>{this.state.meHandleDataLength > 99 ? "99+" : this.state.meHandleDataLength}</div>
                <div style={{padding: "20px 20px 0px", background: 'white', borderRadius: "5px 5px 0px 0px"}}>
                    <Tabs defaultActiveKey={this.state.selectKey} activeKey={this.state.selectKey}
                          onChange={this.handleTextChange}>
                        {tabList.map(item => {
                            return (
                                <TabPane tab={item.title} key={item.key}/>
                            )
                        })}
                    </Tabs>
                </div>
                {/*<div style={{*/}
                {/*    backgroundColor: "red",*/}
                {/*    borderRadius: "50%",*/}
                {/*    width: "20px",*/}
                {/*    height: "20px",*/}
                {/*    position: "absolute",*/}
                {/*    top: 18,*/}
                {/*    left: 432,*/}
                {/*    zIndex: 200,*/}
                {/*    color: "#fff",*/}
                {/*    textAlign: "center",*/}
                {/*    lineHeight: "20px",*/}
                {/*    display: this.state.noPassCount > 0 ? "block" : "none"*/}
                {/*}}>{this.state.noPassCount > 99 ? "99+" : this.state.noPassCount}</div>*/}
                {/*渲染筛选操作*/}
                {this.renderScreenOperate()}
                {/*渲染新媒体矩阵或列表视图*/}
                {
                    this.state.showListOrCard === "cardPage" ? this.renderCardPage() : null
                }
                {
                    this.state.showListOrCard === "listPage" ? this.renderListPage() : null
                }
                {/*渲染历史发文*/}
                {this.renderHistoryList()}
                {/*渲染转交媒体*/}
                {this.renderTransferMedia()}
            </div>
        )
    }

    renderBatchPage() {
        return (
            <div>
                <BatchComponents
                    title={"批量组件"}
                    batchTitle={this.state.batchTitle}
                    batchData={this.state.batchData}
                    height={height}
                    goBack={() => this.goBack()}
                    onAllChange={(checked) => {
                        this.checkedAllChange(checked)
                    }}
                    mediaPlatform={this.state.mediaPlatform}
                    mainDutyDept={this.state.mainDutyDept}
                    onRef={(c) => this.newMediaBatchManage = c}
                    showCurrentPageType={this.state.showCurrentPageType}
                    getNeedAuditMedia={(callback) => this.getNeedAuditMedia(callback)}
                    currentMedia={this.state.currentMedia}
                    batchTransfer={() => this.batchTransfer()}
                    batchAddData={this.state.batchAddData}
                    getTempBatchAdd={() => this.getTempBatchAdd()}
                    batchAuditValueChange={(batchAuditValue) => this.batchAuditValueChange(batchAuditValue)}
                />
            </div>
        )
    }

    batchAuditValueChange(batchAuditValue) {
        // this.newMediaBatchManage.state.checkedAll = true;
        if (batchAuditValue === 0) {
            this.state.batchTitle = "批量新增审核";
        } else if (batchAuditValue === 1) {
            this.state.batchTitle = "批量更新审核";
        } else if (batchAuditValue === 2) {
            this.state.batchTitle = "批量注销审核";
        } else if (batchAuditValue === 3) {
            this.state.batchTitle = "批量删除审核";
        }
        this.setState({
            batchAuditValue
        })
    }

    goBack() {
        this.state.showCurrentPageType = "mainPage";
        this.state.batchAuditValue = undefined;
        this.state.batchData = [];
        this.newMediaBatchManage.state.batchButtons = []; //清空流程按钮
        this.setState({}, () => this.getNeedAuditMedia())
    }

    //渲染历史发文
    renderHistoryList() {
        return (
            <Modal
                title={this.state.historyTitle}
                visible={this.state.visibleHistory}
                onOk={() => {
                    this.setState({})
                }}
                onCancel={() => {
                    this.state.visibleHistory = false;
                    this.setState({})
                }}
                centered={true}
                width={1300}
                maskClosable={false}
                footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Button type={"primary"} onClick={() => {
                        this.state.visibleHistory = false;
                        this.setState({})
                    }}>关闭</Button>
                </div>}
                destroyOnClose
            >
                <HistoryPublish key={uuid()} historyRecord={this.state.historyRecord}/>
            </Modal>
        )
    }

    renderTransferMedia() {
        const column = [
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
                ellipsis: true,
                width: 200,
            },
            {
                title: '账号',
                dataIndex: 'account',
                key: 'account',
                width: 200,
                ellipsis: true,
            },
            {
                title: '角色',
                key: 'roles',
                ellipsis: true,
                width: 400,
                render: (record) => {
                    let roles = [];
                    record.roles.length > 0 && record.roles.forEach(item => {
                        roles.push(item.roleName);
                    })
                    return (
                        <div style={{
                            width: "350px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{roles.join("，")}</div>
                    )
                }
            }
        ]
        return (
            <Modal
                title={"选择被转交人"}
                maskClosable={false}
                className={"transferPerson"}
                visible={this.state.chooseUserVisible}
                onOk={() => {
                    this.state.mediaRoleValue = "";
                    this.state.page = 1;
                    this.saveChooseSqr();
                }}
                onCancel={() => {
                    this.state.mediaRoleValue = "";
                    this.state.page = 1;
                    this.setState({
                        chooseUserVisible: false,
                    });
                }}
                width={920}>
                <div id={"selectTransfer"}>
                    <div style={{paddingBottom: 10}}>
                        <Search
                            allowClear={true}
                            placeholder="搜索姓名/账号"
                            onSearch={(searchValue) => {
                                this.state.page = 1;
                                this.setState({
                                    searchValue
                                },()=>{
                                    this.getMtSqrInfos()
                                })
                            }}
                            value={this.state.mediaRoleValue}
                            onChange={(e) => {
                                this.setState({
                                    mediaRoleValue: e.target.value,
                                });
                            }}
                            style={{width: 200}}
                        />
                    </div>
                    <style>{`.transferPerson .ant-modal-body{padding: 10px 24px 0px 24px}`}</style>

                    <Scrollbars autoHide style={{height: 340}}>
                        <div id={'tableCheck'}><SelectTable selectType={"radio"} column={column}
                                                            dataSource={this.state.mtSqrInfos} style={{border: "none"}}
                                                            getSelectedDatas={this.getSelectedData.bind(this)}/></div>
                    </Scrollbars>
                    {/*<Divider style={{display: this.state.mtSqrInfos.length ? "block" : "none"}}/>*/}
                    <style>{`#selectTransfer .ant-divider-horizontal{margin: 24px 0px 10px 0px;}`}</style>
                    {this.state.mtSqrInfos && this.state.mtSqrInfos.length > 0 ? <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "16px 0",
                        borderTop: "1px solid #ebebeb"
                    }}>
                        <Pagination
                            showQuickJumper
                            current={this.state.page}
                            pageSize={this.state.size}
                            total={this.state.transferTotal}
                            showTotal={total => `共 ${total} 条`}
                            showSizeChanger
                            hideOnSinglePage={this.state.hideOnSinglePage}
                            onChange={(page, pageSize) => this.transferChange(page, pageSize)}
                            onShowSizeChange={(page, pageSize) => {
                                this.state.hideOnSinglePage = false;
                                this.transferChange(page, pageSize)
                            }}
                        />
                    </div> : ""}
                    <style>{`#tableCheck  .ant-table-body{border:none !important}`}</style>
                </div>
            </Modal>);
    }

    transferChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getMtSqrInfos();
    }

    //历史发文
    historyPublish(item) {
        this.state.visibleHistory = true;
        this.setState({
            historyTitle: "历史发布",
            historyRecord: item
        })
    }

    getSelectedData(data) {
        this.state.createBy = data.id;
    }

    getMtSqrInfos(itemUser) {
        let body = {
            start: this.state.page,
            size: this.state.size,
            "queryStr": {
                "queryRelationTypeEnum": "AND",
                "queryList": [
                    {
                        "queryTypeEnum": "NE",
                        "fieldName": "_id",
                        "queryRelationTypeEnum": "AND",
                        "value": window.top.currentUser.id,
                        "valueTypeEnum": "STRING",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "IS",
                        "fieldName": "status",
                        "queryRelationTypeEnum": "AND",
                        "value": "1",
                        "valueTypeEnum": "INT",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "IN",
                        "fieldName": "deptIds",
                        "queryRelationTypeEnum": "AND",
                        "value": window.top.currentUser.deptIds,
                        "valueTypeEnum": "STRING",
                        "queryList": null
                    }
                ]
            },
        };
        if (this.state.mediaRoleValue) {
            body.queryStr.queryList.push({
                "queryRelationTypeEnum": "OR",
                "queryList": [
                    {
                        "queryTypeEnum": "LIKE",
                        "fieldName": "name",
                        "value": transferSpecialCharacter(this.state.mediaRoleValue),
                        "valueTypeEnum": "STRING"
                    },
                    {
                        "queryTypeEnum": "LIKE",
                        "fieldName": "account",
                        "value": transferSpecialCharacter(this.state.mediaRoleValue),
                        "valueTypeEnum": "STRING"
                    },
                ]
            });
        }
        getTransferUsers(body, (data) => {
            this.state.createBy =  "";
            if (data && data.data && data.data.length > 0) {
                let newUser = [];
                let transferTotal = data.count;
                data.data.forEach(item => {
                    newUser.push({name: item.name, account: item.account, roles: item.roleList, id: item.id});
                })
                this.state.hideOnSinglePage = false;
                if(itemUser){
                    this.state.code = itemUser.code;
                    this.state.id = itemUser.id;
                    this.state.statusName = itemUser.statusName;
                    this.state.uuid = itemUser.uuid;
                    this.state.processType = itemUser.processType;
                    this.state.currentMedia = itemUser;
                }
                this.setState({
                    chooseUserVisible: true,
                    mtSqrInfos: newUser,
                    transferTotal
                });
            } else {
                this.state.hideOnSinglePage = true;
                this.setState({
                    mtSqrInfos: [],
                    transferTotal: 0,
                    chooseUserVisible: true
                });
            }
        });
    }

    //保存申请人
    saveChooseSqr() {
        let that = this;
        if (!that.state.createBy) {
            message.warn("请选择被转交人");
            return;
        }
        Modal.confirm({
            title: '请注意，转交操作不可逆',
            content: <div>
                <div style={{color: "red"}}>审核中的媒体在转交后会结束审核流程，</div>
                <div>你还要继续吗？</div>
            </div>,
            okText: '继续',
            cancelText: '取消',
            onOk() {
                if (that.state.processType === 1) {
                    if (that.state.statusName !== "更新审核不通过") {
                        //更新流程转交还原数据
                        that.revertData(() => {
                            that.transferOk(that);
                        });
                    } else {
                        that.newMediaBatchManage.revertToOldData(that.state.currentMedia, () => {
                            that.transferOk(that);
                        });
                    }
                } else {
                    that.transferOk(that);
                }
            },
            onCancel() {
            },
        })
    }

    transferOk(that) {
        let params = {
            codes: [that.state.code],
            receiverAccount: that.state.createBy,
        }
        transferNewMedias(params, (data) => {
            if (data) {
                message.success("转交成功");
                //流程结束
                if (that.state.statusName !== "草稿" && that.state.statusName !== "已备案") {
                    that.flowEnd();
                } else {
                    this.getNeedAuditMedia();
                }
                that.setState({
                    chooseUserVisible: false,
                });
            }
        })
    }

    flowEnd() {
        let params = {
            pojoName: "mediaAudit",
            serviceId: this.state.id
        }
        getFlowEndData(params, (res, status) => {
            if (status === 200) {
                //关闭窗口
                this.getNeedAuditMedia();
            }
        }, {error: ()=>{
                //关闭窗口
                this.getNeedAuditMedia();
        }})
    }

    revertData(callback) {
        getActHistory({bizKey: this.state.uuid}, (data) => {
            if (data && data.length > 0) {
                let historyData = data;
                let oldData = {};
                for (var i = 0; i < historyData.length; i++) {
                    if (historyData[i] && historyData[i].taskName === '已备案') {
                        oldData = historyData[i].processData && historyData[i].processData.data;
                        break;
                    }
                }
                if (oldData) {
                    //把数据恢复到原始的样子；
                    this.newMediaBatchManage.revertToOldData(oldData, callback);
                }
            }
        })
    }

    renderListPage() {
        return (
            <div>
                {/*列表模式组件*/}
                <NewMediaManageList
                    loadListKey={this.state.loadListKey}
                    listData={this.state.listData}
                    onTableClickItem={(item) => {
                        this.clickItem(item)
                    }}
                    onRef={(c) => this.newMediaListManage = c}
                    getMtSqrInfos={(item) => this.getMtSqrInfos(item)}
                    historyPublish={(item) => this.historyPublish(item)}
                />
            </div>
        )
    }

    //点击批量添加查询
    getBatchAdd() {
        getBatchAddData({}, (data) => {
            this.setState({
                batchAddData: data,
                batchTitle: "批量新增",
                showCurrentPageType: "batchPage"
            }, () => {
                this.getTempBatchAdd()
            })
        })
    }

    //批量新增页面刷新列表
    getTempBatchAdd() {
        getTempBatchAddData({}, (data) => {
            if (data && data.length > 0) {
                this.setState({
                    batchAddData: data
                })
            } else {
                this.setState({
                    batchAddData: []
                })
            }
        })
    }


    renderScreenOperate() {
        //新增媒体、批量转交、批量审核、导出媒体权限
        let addMediaLimits = this.permissionCheck("pms:newsMediaManage:addMedia");
        let batchTransferLimits = this.permissionCheck("pms:newsMediaManage:batchTransferMedia");
        let batchAuditLimitsPms = this.permissionCheck("pms:newsMediaManage:batchAuditMedia");
        let exportMediaLimitsPms = this.permissionCheck("pms:newsMediaManage:exportMedia");
        const menu = <Menu style={{width: 120}}>
            <Menu.Item onClick={() => this.addNewMedia()}>新增媒体</Menu.Item>
            <Menu.Item onClick={() => {
                this.getBatchAdd()  //批量暂存数据
            }}>批量新增</Menu.Item>
        </Menu>
        return (
            <div style={{float: 'left', width: "100%", padding: "10px 20px", background: 'white'}} id={"newAddMedia"}>
                <div style={{float: 'left', width: 150, marginRight: "20px"}}><Select className={'mediaListContent'}
                                                                                      placeholder={"媒体平台"}
                                                                                      allowClear
                                                                                      value={this.state.newMediaTypeId ? this.state.newMediaTypeId : undefined}
                                                                                      style={{width: '100%'}}
                                                                                      onChange={(e) => {
                                                                                          this.state.newMediaTypeId = e;
                                                                                          this.getNeedAuditMedia()
                                                                                      }}>
                    {this.state.mediaPlatform && this.state.mediaPlatform.length > 0 && this.state.mediaPlatform.map(item => {
                        return (
                            <Option key={item.id}
                                    value={item.id}>
                                {item.name}
                            </Option>
                        )
                    })}
                </Select></div>
                {this.permissionCheck("pms:accountManage:all") ?
                    <div style={{float: 'left', width: 150, marginRight: "20px"}} id={"mainDept"}><Select className={'mediaListContent'}
                                                                                          placeholder={"主责单位"}
                                                                                          showSearch
                                                                                          filterOption={false}
                                                                                          notFoundContent={null}
                                                                                          onSearch={(value) => {
                                                                                              this.setState({
                                                                                                  selectSearchValue: value,
                                                                                                  mainDeptId: this.permissionCheck("pms:accountManage:all") ? undefined : window.top.currentUser.defaultInfo.dept.id
                                                                                              })
                                                                                          }}
                                                                                          allowClear
                                                                                          value={this.state.mainDeptId ? this.state.mainDeptId : undefined}
                                                                                          style={{width: '100%'}}
                                                                                          onChange={(e) => {
                                                                                              this.state.mainDeptId = e;
                                                                                              this.state.selectSearchValue = "";
                                                                                              this.getNeedAuditMedia()
                                                                                          }}>
                        {this.state.mainDutyDept && this.state.mainDutyDept.length > 0 && this.state.mainDutyDept.map(item => {
                            let showOption = true;
                            if (this.state.selectSearchValue) {
                                showOption = item.name.indexOf(this.state.selectSearchValue) > -1;
                            }
                            return (
                                <Option key={item.id}
                                        style={{display: showOption ? 'block' : 'none'}}
                                        value={item.id}>
                                    {item.name}
                                </Option>
                            )
                        })}
                    </Select></div> : null}
                <style>{`#mainDept .ant-select-selection__placeholder{padding-left: 3px;}`}</style>
                <div style={{float: 'left', width: 150, marginRight: "20px"}}>
                    <Select className={'mediaListContent'}
                            placeholder={"活跃度"}
                            value={(this.state.activeType || this.state.activeType === 0) ? this.state.activeType : undefined}
                            style={{width: '100%'}}
                            allowClear
                            onChange={(e) => {
                                this.state.activeType = e;
                                this.getNeedAuditMedia()
                            }}>
                        <Option value={0}>最近一天</Option>
                        <Option value={1}>最近一周</Option>
                        <Option value={2}>最近一个月</Option>
                        <Option value={3}>最近一年</Option>
                    </Select></div>
                <div style={{float: 'left', width: 150, marginRight: "20px"}}>
                    <Select className={'mediaListContent'}
                            placeholder={"媒体等级"}
                            value={this.state.grade ? this.state.grade : undefined}
                            style={{width: '100%'}}
                            allowClear
                            onChange={(e) => {
                                this.state.grade = e;
                                this.getNeedAuditMedia()
                            }}>
                        <Option value={"first"}>一级（{this.state.num1}）</Option>
                        <Option value={"second"}>二级（{this.state.num2}）</Option>
                        <Option value={"third"}>三级（{this.state.num3}）</Option>
                    </Select></div>
                <style>{`.mediaListContent .ant-select-selection{border: 1px solid #EEF2FB; background-color: #F6F8FD;}`}</style>
                <div style={{float: 'left', marginRight: "20px", height: "37px", lineHeight: "37px"}}><Button
                    type={"primary"} onClick={() => {
                    this.revertScreen()
                }}>重置</Button></div>
                <div style={{float: "right", paddingTop: "4px"}}>
                    {(exportMediaLimitsPms) ?
                        <div style={{
                            float: "left",
                            cursor: 'pointer',
                            marginRight: "10px",
                            marginBottom: "10px"
                        }}>
                            <Button onClick={() => {
                                this.exportMedia()
                            }} type="default">导出媒体</Button>
                        </div> : null}
                    {batchTransferLimits ?
                        <div style={{
                            float: "left",
                            cursor: 'pointer',
                            marginRight: "10px",
                            marginBottom: "10px"
                        }}>
                            <Button onClick={() => {
                                this.batchTransfer("clickTransfer");
                            }} type="default">批量转交</Button>
                        </div> : null}
                    {(batchAuditLimitsPms) && this.state.selectKey === "2" ?
                        <div id={"batchAudit"} style={{
                            float: "left",
                            cursor: 'pointer',
                            marginRight: "10px",
                            marginBottom: "10px"
                        }}>
                            <Select placeholder={"批量审核"} style={{float: 'left', width: "105px"}}
                                    defaultValue={this.state.batchAuditValue}
                                    value={this.state.batchAuditValue}
                                    onSelect={(e) => {
                                        if (e === 0) {
                                            this.state.batchTitle = "批量新增审核";
                                        } else if (e === 1) {
                                            this.state.batchTitle = "批量更新审核";
                                        } else if (e === 2) {
                                            this.state.batchTitle = "批量注销审核";
                                        } else if (e === 3) {
                                            this.state.batchTitle = "批量删除审核";
                                        }
                                        this.setState({
                                            batchAuditValue: e,
                                            showCurrentPageType: "batchPage"
                                        }, () => {
                                            // this.newMediaBatchManage.state.checkedAll = true;
                                            this.getNeedAuditMedia((batchData) => {
                                                if (batchData.length > 0) {
                                                    this.newMediaBatchManage && this.newMediaBatchManage.initProcess(batchData);
                                                }
                                            });
                                        });
                                    }}>
                                <Option value={0}>新增</Option>
                                <Option value={1}>更新</Option>
                                <Option value={2}>注销</Option>
                                <Option value={3}>删除</Option>
                            </Select>
                            <style>{`#batchAudit .ant-select-selection__placeholder{color: #0050b3;}`}</style>
                        </div> : null}
                    {
                        addMediaLimits ?
                            <div style={{
                                float: "left", cursor: 'pointer',
                                marginRight: "10px", marginBottom: "10px"
                            }}>
                                <Dropdown.Button
                                    onClick={() => {
                                        this.addNewMedia()
                                    }}
                                    type={"primary"}
                                    overlay={menu}
                                    placement="bottomRight">
                                    新增媒体
                                </Dropdown.Button>
                            </div> : null
                    }
                    <div style={{
                        float: "left", cursor: 'pointer',
                        marginRight: "10px", marginBottom: "10px", marginTop: "3px"
                    }}>
                        <img onClick={this.checkedList} className={"tableChangeBtn"} style={{width: 17, height: 17}}
                             src={this.state.listChecked ? list : otherList} title={"列表模式"} alt="列表模式"/>
                        <img onClick={this.checkedCard} className={"tableChangeBtn"} style={{width: 17, height: 17}}
                             src={this.state.cardChecked ? card : otherCard} title={"卡片模式"} alt="卡片模式"/>
                    </div>
                    <style>
                        {`
                        .tableChangeBtn {width:25px;height:25px;cursor:pointer;margin-left:10px;object-fit:cover;}
                        #newAddMedia .ant-btn-group .ant-btn + .ant-btn{margin-left: 1px;}
                        `}
                    </style>
                </div>
                {/*渲染新增媒体*/}
                <NewAddMedia
                    title={this.state.title}
                    onRef={(newAddMedia) => this.newAddMedia = newAddMedia}
                    currentMedia={this.state.currentMedia}
                    mainDutyDept={this.state.mainDutyDept}
                    mediaPlatform={this.state.mediaPlatform}
                    currentUser={this.props.currentUser}
                    showCurrentPageType={this.state.showCurrentPageType}
                    getNeedAuditMedia={() => this.getNeedAuditMedia()}
                    getById={(item) => this.getById(item)}
                />
            </div>
        )
    }

    revertScreen() {
        this.setState({
            newMediaTypeId: undefined,
            mainDeptId: this.permissionCheck("pms:accountManage:all") ? undefined : window.top.currentUser.defaultInfo.dept.id,
            activeType: undefined,
            grade: undefined,
        }, () => {
            this.getNeedAuditMedia()
        })
    }

    exportMedia() {
        if (this.state.idArr.length === 0) {
            message.error("没有可供导出的数据");
            return;
        }
        Modal.confirm({
            title: "确认导出吗？",
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                let body = {
                    newMediaIds: this.state.idArr
                }
                exportMediaData(body, (data) => {

                }, {
                    error: (error) => {
                        message.error(error);
                    }
                })
            }
        })
    }

    checkedCard = () => {
        this.setState({
            showCurrentPageType: "mainPage",
            showListOrCard: "cardPage",
            listChecked: false,
            cardChecked: true
        })
    }

    checkedList = () => {
        // this.state.listData.forEach(item => {
        //     item.checked = true;
        // });
        this.setState({
            showCurrentPageType: "mainPage",
            showListOrCard: "listPage",
            listChecked: true,
            cardChecked: false
        })
    }

    //批量转交
    batchTransfer(operate) {
        let body = {};
        getBatchTransferNewMedias(body, (res) => {
            if (res && res.length) {
                this.state.batchData = res;
                this.setState({
                    showCurrentPageType: "batchPage",
                    batchTitle: "批量转交"
                })
            } else {
                if (operate) {
                    message.error("暂无批量转交数据！");
                }
                this.setState({
                    batchData: []
                })
            }
        });
        this.newMediaBatchManage.state.checkedAll = false;
        this.newMediaBatchManage.state.transferPersonBtnShow = true;
        this.newMediaBatchManage.state.selectedTransferPerson = null;
    }

    addNewMedia() {
        this.state.title = "新增媒体";
        this.setState({});
        this.newAddMedia && this.newAddMedia.openModal();
        this.newAddMedia && this.newAddMedia.revert();
        this.newAddMedia && this.newAddMedia.initNewMediaAct({});
    }

    renderCardPage() {
        let height = window.innerHeight - 251;
        let scrollHeight = document.body.scrollHeight;
        if(scrollHeight < 852 || (window.screen.height >= 768 && window.screen.height < 1080)){
            height = window.innerHeight - 291;
        }
        let operateTypeToName = {'0': '新增', '1': '更新', '2': '注销', '3': "删除"};
        let operateTypeToColor = {'0': '#0050B3', '1': '#B684F2', '2': '#FFB038', '3': '#F56C6C'};
        let operateBackgroundColor = {
            '0': 'rgba(0, 80, 179, 0.05)',
            '1': 'rgba(182, 132, 242, 0.05)',
            '2': 'rgba(255, 176, 56, 0.05)',
            '3': 'rgba(245, 108, 108, 0.05)'
        }
        return (
            <div style={{marginTop: "20px", padding: "20px", background: 'white', borderRadius: "5px"}} id={"mainPage"}>
                <Scrollbars key={this.state.loadListKey} autoHide autoHeight autoHeightMax={height}>
                    {
                        this.state.newMediaListData.length === 0 ? <Empty/> : null
                    }
                    {this.state.newMediaListData && this.state.newMediaListData.length > 0 && this.state.newMediaListData.map((testItem, testIndex) => {
                        let isExpandDiv;
                        if (testIndex < 4) {
                            if (!testItem.isExpand) {
                                isExpandDiv = (<div style={{
                                    textAlign: "center",
                                    margin: "10px",
                                    cursor: "pointer",
                                    display: testItem.data.length > 4 ? "block" : "none"
                                }}
                                                    onClick={() => {
                                                        testItem.isExpand = true;
                                                        this.setState({})
                                                    }}>查看更多</div>)
                            } else {
                                isExpandDiv = (<div style={{
                                    textAlign: "center",
                                    margin: "10px",
                                    cursor: "pointer",
                                    display: testItem.data.length > 4 ? "block" : "none"
                                }}
                                                    onClick={() => {
                                                        testItem.isExpand = false;
                                                        this.setState({})
                                                    }}>收起</div>)
                            }
                        }
                        return (
                            <div key={testIndex} style={{padding: "10px 0px"}}>
                                <div style={{marginBottom: "5px"}}><img
                                    style={{width: "15px", height: "15px", objectFit: "cover", borderRadius: "50%"}}
                                    src={testItem.logo ? testItem.logo : noImg}/><span
                                    style={{verticalAlign: "middle", marginLeft: "5px"}}>{testItem.name}</span></div>
                                <style>
                                    {`.packUp {display:flex;align-items:center;flex-wrap:wrap;height:143px;overflow-y:hidden;}`}
                                    {`.expand {display:flex;align-items:center;flex-wrap:wrap;height:auto;}`}
                                </style>
                                <div className={(!testItem.isExpand) ? "packUp" : "expand"}>
                                    {testItem.data.map((item, index) => {
                                        return (
                                            <div key={index} style={{paddingRight: 12, paddingBottom: "10px"}}>
                                                <NewMediaInformation
                                                    title={item.name}
                                                    iconUrl={item.logo ? item.logo : ""}
                                                    mark={item.name ? item.name : ''}
                                                    leader={item.leader}
                                                    mainDeptName={item.mainDeptName}
                                                    accountNumber={item.account}
                                                    customWidth={itemWidth}
                                                    statusName={item.statusName}
                                                    createById={item.createById}
                                                    operateType={operateTypeToName[item.processType]}
                                                    operateColor={operateTypeToColor[item.processType]}
                                                    operateBackgroundColor={operateBackgroundColor[item.processType]}
                                                    needTodo={item.needTodo}
                                                    keepRecordIconShow={item.status === "已备案" ? true : false}
                                                    defaultImg={noImg}
                                                    onClickFunction={() => {
                                                        this.clickItem(item)
                                                    }}
                                                    onClickBottomLeftFunction={() => {
                                                        this.onClickBottomLeftFunction(item)
                                                    }}
                                                    onClickBottomRightFunction={() => {
                                                        this.onClickBottomRightFunction(item)
                                                    }}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                                {isExpandDiv}
                            </div>
                        )
                    })}
                </Scrollbars>
                <style>{`#mainPage .ant-empty{margin: 8px;}`}</style>
            </div>
        )
    }

    onClickBottomLeftFunction(item) {
        this.historyPublish(item);
    }

    onClickBottomRightFunction(item) {
        this.getMtSqrInfos(item);
    }

    clickItem(item) {
        this.getById(item);
    }

    getById(item, processCallback) {
        let body = {
            id: item.id
        }
        getNewMediaById(body, (data) => {
            if(data){
                if(data.processType === 0 && data.statusName !== "新增审核不通过" && data.statusName !== "草稿" && data.statusName !== "已备案"){
                    this.state.title = "新增媒体审核";
                }else if(data.processType === 1 && data.statusName.indexOf("审核不通过") === -1 && data.statusName !== "已备案"){
                    this.state.title = "更新媒体审核";
                }else if(data.processType === 2 && data.statusName.indexOf("审核不通过") === -1 && data.statusName !== "已备案" && data.statusName !== "已注销"){
                    this.state.title = "注销媒体审核";
                }else if(data.processType === 3 && data.statusName.indexOf("审核不通过") === -1 && data.statusName !== "已备案"){
                    this.state.title = "删除媒体审核";
                }else if(data.statusName === "新增审核不通过"){
                    this.state.title = "新增媒体";
                }else {
                    this.state.title = "媒体信息";
                }
            }
            if (processCallback && !data) {
                processCallback(false);
                return false
            }
            this.setState({
                currentMedia: data
            }, () => {
                this.newAddMedia && this.newAddMedia.openModal();
                this.newAddMedia && this.newAddMedia.init(data, null, processCallback);
            })
        })
    }
}

class HistoryPublish extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            statusName: '发布',//发布状态
            startDate: null,//开始时间
            endDate: null,//结束时间
            searchText: '',//搜索的文字
            mediaType: this.props.historyRecord.newMediaTypeName,
            page: 1,//当前页数
            size: 10,//当前页数据条数,
            dataSource: [],//列表数据源
            totalElements: 0,//总条数
            hideOnSinglePage: true
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList()
    }

    getList() {
        let type = this.props.historyRecord.newMediaTypeName;
        if (type === "公众号") {
            this.getWechatList();
        }
        if (type === "微博") {
            this.getWeiBoList();
        }
        if (type === "抖音") {
            this.getDouyinList();
        }
    }


    //获取微信列表
    getWechatList() {
        let startDate = this.state.startDate ? new Date(this.state.startDate).getTime() : null;
        let endDate = this.state.endDate ? new Date(this.state.endDate).getTime() : null;
        let body = {
            pageNum: this.state.page,//当前页后台起始页从1开始
            pageSize: this.state.size,//当前页面
            mediaCodes: this.props.historyRecord.code
        };
        if (startDate) {
            body.startTime = startDate;
        }
        if (endDate) {
            body.endTime = endDate;
        }
        if (this.state.searchText) {
            body.search = encodeURIComponent(this.state.searchText);
        }
        getWechatList(body, (data) => {
            if (data && data.content && data.content.length > 0) {
                this.state.hideOnSinglePage = false;
                let list = data.content;
                list.forEach((item, i) => {
                    item.sort = i + 1;//序号
                });
                this.setState({
                    dataSource: list,
                    totalElements: data.totalElements,
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })

            } else {
                this.state.hideOnSinglePage = true;
                this.setState({
                    dataSource: [],
                    totalElements: 0,
                })
            }
        })
    }

    //获取微博列表
    getWeiBoList() {
        let startDate = this.state.startDate ? new Date(this.state.startDate).getTime() : null;//YYYY-MM-DD HH:mm:ss
        let endDate = this.state.endDate ? new Date(this.state.endDate).getTime() : null;
        let body = {
            pageNum: this.state.page,//当前页后台起始页从1开始
            pageSize: this.state.size,//当前页面
            mediaCodes: this.props.historyRecord.code
        };
        if (startDate) {
            body.startTime = startDate;
        }
        if (endDate) {
            body.endTime = endDate;
        }
        if (this.state.searchText) {
            body.search = encodeURIComponent(this.state.searchText);
        }
        getWeiBoList(body, (data) => {
            if (data && data.content && data.content.length > 0) {
                this.state.hideOnSinglePage = false;
                let list = data.content;
                list.forEach((item, i) => {
                    item.sort = i + 1;//序号
                })
                this.setState({
                    dataSource: list,
                    totalElements: data.totalElements,
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })

            } else {
                this.state.hideOnSinglePage = true;
                this.setState({
                    dataSource: [],
                    totalElements: 0,
                })
            }
        })
    }

    //获取抖音列表
    getDouyinList() {
        let startDate = this.state.startDate ? new Date(this.state.startDate).getTime() : null;//YYYY-MM-DD HH:mm:ss
        let endDate = this.state.endDate ? new Date(this.state.endDate).getTime() : null;
        let body = {
            pageNum: this.state.page,//当前页后台起始页从1开始
            pageSize: this.state.size,//当前页面
            mediaCodes: this.props.historyRecord.code
        };
        if (startDate) {
            body.startTime = startDate;
        }
        if (endDate) {
            body.endTime = endDate;
        }
        if (this.state.searchText) {
            body.search = encodeURIComponent(this.state.searchText);
        }
        getDouYinList(body, (data) => {
            if (data && data.content && data.content.length > 0) {
                this.state.hideOnSinglePage = false;
                let list = data.content;
                list.forEach((item, i) => {
                    item.sort = i + 1;//序号
                })
                this.setState({
                    dataSource: list,
                    totalElements: data.totalElements,
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })

            } else {
                this.state.hideOnSinglePage = true;
                this.setState({
                    dataSource: [],
                    totalElements: 0,
                })
            }
        })
    }


    render() {
        return (
            <div className={'HistoryPublish'}
                 style={{position: 'relative'}}>
                <div style={{background: 'white'}}>
                    {this.renderScreen()}
                    {!(this.props.historyRecord.newMediaTypeName === "微博" || this.props.historyRecord.newMediaTypeName === "抖音" || this.props.historyRecord.newMediaTypeName === "公众号") ?
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/> : ""}
                    {this.props.historyRecord.newMediaTypeName === "公众号" ? this.renderWechat() : null}
                    {this.props.historyRecord.newMediaTypeName === "微博" || this.props.historyRecord.newMediaTypeName === "抖音" ? this.renderWeiboOrDouyin() : null}

                    {/*// 微信预览*/}
                    <WeChatReview ref={(WeChatReview) => {
                        this.WeChatReview = WeChatReview
                    }}/>
                    {/*微博预览*/}
                    <MicroBlogReview ref={(MicroBlogReview) => {
                        this.MicroBlogReview = MicroBlogReview
                    }}/>
                    {/*抖音预览*/}
                    <TiktokReview ref={(TiktokReview) => {
                        this.TiktokReview = TiktokReview
                    }}/>
                </div>
            </div>
        )
    }

    //渲染筛选条件
    renderScreen() {
        return (
            <div style={{display: "flex", alignItems: "center",marginBottom:"24px"}}>
                <div style={{float: 'left'}}>
                    <div style={{float: 'left'}}>
                        <div className={'HistoryPublishTitle'} style={{float: 'left'}}>自定义时间</div>
                        <style>{
                            `.HistoryPublishTitle{
                                height: 45px;
                                line-height: 45px;
                                font-size: 14px;
                                padding-left: 10px;
                                padding-right: 10px;
                            } `
                        }</style>
                        <div key={uuid()} style={{float: 'left', width: 350, marginTop: 6}}>
                            <RangePicker
                                value={[this.state.startDate, this.state.endDate]}
                                showTime={{defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}}
                                showClear
                                onChange={(moment1, moment2) => {
                                    if (!moment1 || !moment2) {
                                        return;
                                    }
                                    let startDate = moment2[0] ? moment(moment2[0]) : null;
                                    let endDate = moment2[1] ? moment(moment2[1]) : null;
                                    this.state.startDate = startDate;
                                    this.state.endDate = endDate;
                                    this.TypeChange();
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{float: 'left', paddingLeft: 20,}}>
                    <div style={{height: 35}}><Search className={'HistoryPublishContent'}
                                                      placeholder="搜索"
                                                      enterButton="查询"
                                                      size="default"
                                                      value={this.state.searchText}
                                                      onChange={(e) => {
                                                          this.setState({
                                                              searchText: e.target.value
                                                          });
                                                      }}
                                                      onSearch={value => {
                                                          this.search();
                                                      }}
                    /></div>
                    <style>{
                        `.HistoryPublishContent{
                                height: 35px;
                                line-height: 35px;
                            } `
                    }</style>
                </div>
                <div style={{float: 'left', paddingLeft: 20, height: "35px"}}>
                    <Button onClick={() => {
                        this.revert()
                    }} type="primary">重置</Button>
                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    //渲染微信内容
    renderWechat() {
        let titleKeyList =
            [{
                key: 'title',
                titleName: '标题',
                align: 'left',
                ellipsis: true,
                render: (text, record, index) => {
                    return (<div onClick={() => {
                            this.itemClick(record)
                        }}>
                            <div style={{position: 'relative',}}>
                                <div style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold', textAlign: 'left', cursor: 'pointer', width: 530
                                }}
                                     title={record.title}>{record.title}</div>
                            </div>

                        </div>

                    )
                }
            },
                {
                    key: 'statDate',
                    titleName: '发布时间',
                    align: 'left',
                    ellipsis: true,
                    width: 200,
                    render: (text, record, index) => {
                        return (<div title={record.statDate ? formatDate(record.statDate) : ""} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {record.statDate ? formatDate(record.statDate) : ""}
                            </div>

                        )
                    }
                },
                {
                    key: 'mediaName',
                    titleName: '账号名称',
                    align: 'left',
                    ellipsis: true,
                    width: 200,
                    render: (text, record, index) => {
                        return (<div title={record.mediaName} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {record.mediaName}
                            </div>

                        )
                    }
                },
                {
                    key: 'newsReadCount',
                    titleName: '阅读数',
                    width: 100,
                    align: 'left',
                    render: (text, record, index) => {
                        return (<div title={record.readNum} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {formatCount(record.readNum)}
                            </div>

                        )
                    }
                },
                {
                    key: 'deptName',
                    titleName: '主责单位',
                    align: 'left',
                    ellipsis: true,
                    width: 200,
                    render: (text, record, index) => {
                        return (<div title={record.deptName} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {record.deptName}
                            </div>

                        )
                    }
                }];
        return (
            <div className={'mediaHistory'}>
                <Scrollbars autoHide autoHeight autoHeightMax={610}>
                    <CustomTable
                        defineStyle={{padding: 0, backgroundColor: "white"}}
                        bordered={false}
                        dataSource={this.state.dataSource}
                        titleKeyList={titleKeyList}
                        childrenColumnName={['stuffList']}
                        pagination={false}
                    />
                </Scrollbars>
                <Divider style={{display: this.state.dataSource.length ? "block" : "none"}}/>
                <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                    <Pagination
                        showQuickJumper
                        current={this.state.page}
                        pageSize={this.state.size}
                        total={this.state.totalElements}
                        showTotal={total => `共 ${total} 条`}
                        showSizeChanger
                        hideOnSinglePage={this.state.hideOnSinglePage}
                        onChange={(page, pageSize) => this.paginationChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.showSizeChange(page, pageSize)
                        }}
                    />
                </div>
            </div>
        )
    }

    //渲染微博抖音内容
    renderWeiboOrDouyin() {
        let titleKeyList =
            [{
                key: 'title',
                titleName: '标题',
                align: 'left',
                ellipsis: true,
                render: (text, record, index) => {
                    return (<div onClick={() => {
                            this.itemClick(record)
                        }}>
                            <div style={{position: 'relative',}}>
                                <div style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold', textAlign: 'left', cursor: 'pointer', width: 530
                                }}
                                     title={this.state.mediaType === "抖音" ? record.title : record.text}>{this.state.mediaType === "抖音" ? (record.title ? record.title : '无标题') : record.text}</div>
                            </div>
                        </div>
                    )
                }
            },
                {
                    key: 'createTime',
                    titleName: '发布时间',
                    align: 'left',
                    ellipsis: true,
                    width: 200,
                    render: (text, record, index) => {
                        if (this.state.mediaType === "微博") {
                            return (<div title={record.createdAt ? formatDate(record.createdAt) : ""} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                    {record.createdAt ? formatDate(record.createdAt) : ""}
                                </div>
                            )
                        } else {
                            return (<div title={record.createTime ? formatDate(record.createTime) : ""} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                    {record.createTime ? formatDate(record.createTime) : ""}
                                </div>
                            )
                        }
                    }
                },
                {
                    key: 'account',
                    titleName: '账号名称',
                    align: 'left',
                    ellipsis: true,
                    width: 200,
                    render: (text, record, index) => {
                        return (<div title={record.mediaName} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {record.mediaName}
                            </div>

                        )
                    }
                },
                {
                    key: this.state.mediaType === "微博" ? 'zpzCount' : 'playCount',
                    titleName: '转评赞',
                    width: 100,
                    align: 'left',
                    render: (text, record, index) => {
                        let num;
                        if (this.state.mediaType === "微博") {
                            num = record.orderCount ? record.orderCount : 0
                        } else {
                            num = (record.statistics && record.statistics.playCount) ? record.statistics.playCount : 0
                        }
                        return (
                            <div
                                style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
                                title={this.state.mediaType === "微博" ? record.orderCount : record.statistics.playCount}>
                                {formatCount(num)}
                            </div>

                        )
                    }
                }, {
                key: 'deptName',
                titleName: '主责单位',
                align: 'left',
                ellipsis: true,
                width: 200,
                render: (text, record, index) => {
                    return (<div title={record.deptName} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                            {record.deptName}
                        </div>

                    )
                }
            }];
        return (
            <div>
                <Scrollbars autoHide autoHeight autoHeightMax={610}>
                    <CustomTable
                        defineStyle={{padding: 0, backgroundColor: "white"}}
                        bordered={false}
                        dataSource={this.state.dataSource}
                        titleKeyList={titleKeyList}
                        childrenColumnName={['stuffList']}
                        pagination={false}
                    />
                </Scrollbars>
                <Divider style={{display: this.state.dataSource.length ? "block" : "none"}}/>
                <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                    <Pagination
                        showQuickJumper
                        current={this.state.page}
                        pageSize={this.state.size}
                        total={this.state.totalElements}
                        showTotal={total => `共 ${total} 条`}
                        showSizeChanger
                        hideOnSinglePage={this.state.hideOnSinglePage}
                        onChange={(page, pageSize) => this.paginationChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.showSizeChange(page, pageSize)
                        }}
                    />
                </div>
            </div>
        )
    }

    //下拉改变
    TypeChange() {
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getList()
    }

    //查询方法
    search() {
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getList();
    }

    //点击重置按钮
    revert() {
        this.state.startDate = null;// moment().add(-1, 'days');//开始时间
        this.state.endDate = null;//moment().add(-1, 'days');//结束时间
        this.state.searchText = '';//搜索的文字
        this.state.page = 1;//当前页
        this.state.size = 10;//当前页数据条数
        this.getList()
    }

    paginationChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getList();
    }

    showSizeChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getList();
    }

    itemClick(record) {
        let type = this.props.historyRecord.newMediaTypeName;
        if (type === "公众号") {
            //微信预览
            openNewWindow(record.link)
        }
        if (type === "微博") {
            //微博预览
            openNewWindow(record.shareUrl)
        }
        if (type === "抖音") {
            //抖音预览
            openNewWindow(record.shareUrl)
        }

    }


}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(NewMediaManagement);